export const APP_VERSION = 'v2026.1008.03';
